import { render } from "./PatientSchedule.vue?vue&type=template&id=37cc386c"
import script from "./PatientSchedule.vue?vue&type=script&lang=js"
export * from "./PatientSchedule.vue?vue&type=script&lang=js"

import "./PatientSchedule.vue?vue&type=style&index=0&id=37cc386c&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__